// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1C3__","title":"Info_title__3BqIc","selects":"Info_selects__MK9gK","requiredAsterisk":"Info_requiredAsterisk__HsFWm"};